import {Box as MUIBox, BoxProps as MUIBoxProps} from '@mui/material';

export interface BoxProps extends MUIBoxProps {
  autoComplete?: string;
  noValidate?: boolean;
}

const Box = (props: BoxProps) => {
  return <MUIBox {...props}>{props.children}</MUIBox>;
};

export {Box};
